<template>
  <div>
    <input
      v-for="n in numDigits"
      v-model="digits[n - 1]"
      :key="n"
      :ref="`n${n - 1}`"
      :disabled="disabled"
      class="input"
      type="number"
      step="1"
      min="0"
      max="9"
      @keyup.enter="complete"
      @keyup.delete="backspace"
      @focus="index = n - 1"
    />
  </div>
</template>

<script>
export default {
  props: ['length', 'disabled'],

  data: function () {
    return {
      digits: [],
      index: 0,
      watch: true
    }
  },

  computed: {
    numDigits: function () {
      return parseInt(this.length)
    },
    code: function () {
      return this.digits.length ? this.digits.join('') : ''
    }
  },

  watch: {
    digits: function () {
      if (this.watch) {
        if (this.index === 0 && this.code.length > 2) {
          this.paste()
        } else {
          this.check(this.index)
        }
      }
    }
  },

  mounted: function () {
    this.init()
  },

  methods: {
    init: function () {
      if (this.numDigits > 0) {
        this.digits = new Array(this.numDigits)
        this.$nextTick(() => { this.focus(0) })
      }
    },

    check: function (n) {
      let value = this.digits[n]
      if (!value) {
        return
      }

      if (value.length > 1) {
        value = value.substring(value.length - 1)
        this.$set(this.digits, n, value)
      }

      this.emit()

      if (n < this.numDigits - 1) {
        this.focus(n + 1)
      } else {
        this.complete()
      }
    },

    focus: function (n) {
      const el = this.$refs[`n${n}`]
      if (el) {
        el[0].focus()
      }
    },

    emit: function () {
      this.$emit('input', this.code)
    },

    complete: function () {
      if (this.code.length === this.numDigits) {
        this.$emit('complete')
      }
    },

    backspace: function () {
      const value = this.digits[this.index]
      if (!value) {
        if (this.index > 0) {
          this.focus(this.index - 1)
        }
      }
    },

    paste: function () {
      this.watch = false

      this.code.split('').forEach((d, n) => {
        if (n < this.numDigits) {
          this.$set(this.digits, n, parseInt(d) || 0)
        }
      })

      this.emit()

      if (this.code.length === this.numDigits) {
        this.complete()
        this.focus(this.numDigits - 1)
      } else {
        this.focus(this.code.length)
      }

      this.$nextTick(() => { this.watch = true })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  div {
    display: flex;
    justify-content: space-between;
  }

  input[type=number] {
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    width: 3rem;
    height: 3rem;
    font-size: 1.5rem;
    margin:0.4rem;

    @include mobile{
      margin: 0.2rem;
      width: 2.7rem;
      height: 2.7rem;
    }
  }
</style>
